// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var AlertAction;
(function (AlertAction) {
    AlertAction[AlertAction["PLACE_ORDER_NOTIFY"] = 0] = "PLACE_ORDER_NOTIFY";
    AlertAction[AlertAction["NOTIFY"] = 1] = "NOTIFY"; // Значение по умолчанию
})(AlertAction || (AlertAction = {}));
export var AlertEvent;
(function (AlertEvent) {
    AlertEvent[AlertEvent["DELETED"] = 1] = "DELETED";
    AlertEvent[AlertEvent["EXECUTED"] = 2] = "EXECUTED";
    AlertEvent[AlertEvent["EXPIRED"] = 3] = "EXPIRED";
    AlertEvent[AlertEvent["CREATED"] = 4] = "CREATED";
    AlertEvent[AlertEvent["MODIFIED"] = 5] = "MODIFIED";
    AlertEvent[AlertEvent["RESTARTED"] = 6] = "RESTARTED";
})(AlertEvent || (AlertEvent = {}));
export var AlertStatus;
(function (AlertStatus) {
    AlertStatus[AlertStatus["ACTIVE"] = 0] = "ACTIVE";
    AlertStatus[AlertStatus["NOT_ACTIVE"] = 1] = "NOT_ACTIVE";
})(AlertStatus || (AlertStatus = {}));
// избражение для кнопок в таблице
export var AlertSubImage;
(function (AlertSubImage) {
    AlertSubImage[AlertSubImage["PLAY_STOP"] = 0] = "PLAY_STOP";
    AlertSubImage[AlertSubImage["UPDATE"] = 1] = "UPDATE";
    AlertSubImage[AlertSubImage["CLOSE"] = 2] = "CLOSE";
})(AlertSubImage || (AlertSubImage = {}));
export var AlertActions;
(function (AlertActions) {
    AlertActions[AlertActions["START"] = 0] = "START";
    AlertActions[AlertActions["STOP"] = 1] = "STOP";
    AlertActions[AlertActions["DELETE"] = 2] = "DELETE";
})(AlertActions || (AlertActions = {}));
// должен быть множественный выбор параметров./
export var AlertNotification;
(function (AlertNotification) {
    AlertNotification[AlertNotification["SHOW_POP_UP"] = 1] = "SHOW_POP_UP";
    AlertNotification[AlertNotification["SOUND"] = 2] = "SOUND";
    AlertNotification[AlertNotification["EMAIL"] = 4] = "EMAIL";
    AlertNotification[AlertNotification["PUSH"] = 8] = "PUSH";
    // 1=Popup, 2=Sound, 4=Email, 8=Push  из доки не брать, Макс написал https://tp.traderevolution.com/entity/90577
})(AlertNotification || (AlertNotification = {}));
export const AlertNotificationMap = {
    1: 'Show Pop-up', // Значение по умолчанию
    2: 'Sound',
    4: 'Email',
    8: 'Push'
};
export var AlertType;
(function (AlertType) {
    AlertType[AlertType["ASK"] = 0] = "ASK";
    AlertType[AlertType["BID"] = 1] = "BID";
    AlertType[AlertType["LAST"] = 2] = "LAST";
    AlertType[AlertType["CHANGE"] = 3] = "CHANGE";
    AlertType[AlertType["VOLUME"] = 4] = "VOLUME";
})(AlertType || (AlertType = {}));
export const AlertTypeMap = {
    0: 'Ask',
    1: 'Bid',
    2: 'Last',
    3: 'ChangePr',
    4: 'Volume'
};
export var AlertImportance;
(function (AlertImportance) {
    AlertImportance[AlertImportance["HIGH"] = 1] = "HIGH";
    AlertImportance[AlertImportance["MEDIUM"] = 5] = "MEDIUM";
    AlertImportance[AlertImportance["LOW"] = 10] = "LOW";
})(AlertImportance || (AlertImportance = {}));
export var AlertCondition;
(function (AlertCondition) {
    AlertCondition[AlertCondition["MORE"] = 0] = "MORE";
    AlertCondition[AlertCondition["LESS"] = 1] = "LESS";
    AlertCondition[AlertCondition["MORE_EQUAL"] = 2] = "MORE_EQUAL";
    AlertCondition[AlertCondition["LESS_EQUAL"] = 3] = "LESS_EQUAL";
})(AlertCondition || (AlertCondition = {}));
export const AlertSymbolConditionMap = {
    0: '>',
    1: '<',
    2: '>=',
    3: '<='
};
export var AlertAfterExecute;
(function (AlertAfterExecute) {
    AlertAfterExecute[AlertAfterExecute["STOP"] = 0] = "STOP";
    AlertAfterExecute[AlertAfterExecute["REMOVE"] = 1] = "REMOVE";
})(AlertAfterExecute || (AlertAfterExecute = {}));
export function getAlertTypeKey(alertType) {
    switch (alertType) {
        case AlertType.ASK:
            return 'screen.Alerts.Ask';
        case AlertType.BID:
            return 'screen.Alerts.Bid';
        case AlertType.LAST:
            return 'screen.Alerts.Last';
        case AlertType.CHANGE:
            return 'screen.Alerts.ChangePr';
        case AlertType.VOLUME:
            return 'screen.Alerts.Volume';
        default:
            return '';
    }
}
export function getAlertImportanceKey(alertImportance) {
    switch (alertImportance) {
        case AlertImportance.HIGH:
            return 'screen.Alerts.Importance.High';
        case AlertImportance.MEDIUM:
            return 'screen.Alerts.Importance.Medium';
        case AlertImportance.LOW:
            return 'screen.Alerts.Importance.Low';
        default:
            return '';
    }
}
export function getAlertConditionKey(alertCondition) {
    switch (alertCondition) {
        case AlertCondition.MORE:
            return 'screen.Alerts.Condition.Greater';
        case AlertCondition.LESS:
            return 'screen.Alerts.Condition.Less';
        case AlertCondition.MORE_EQUAL:
            return 'screen.Alerts.Condition.Greater or equal';
        case AlertCondition.LESS_EQUAL:
            return 'screen.Alerts.Condition.Less or equal';
        default:
            return '';
    }
}
export function getAlertAfterExecuteKey(alertAfterExecute) {
    switch (alertAfterExecute) {
        case AlertAfterExecute.STOP:
            return 'screen.Alerts.AfterExecute.Stop';
        case AlertAfterExecute.REMOVE:
            return 'screen.Alerts.AfterExecute.Remove';
        default:
            return '';
    }
}
